package kz.dentalcrm.app.data.network.response_model.diagnosis

import kotlinx.serialization.Serializable

@Serializable
data class Meta(
    val current_page: Int? = null,
    val from: Int? = null,
    val last_page: Int? = null,
    val path: String? = null,
    val per_page: Int? = null,
    val to: Int? = null,
    val total: Int? = null
)